export default function (axios) {
  return {
    getPages(params) {
      return axios.get('/modules/pages', params)
    },

    getPage(id, params) {
      return axios.get(`/modules/pages/${id}`, params)
    },
  }
}
